{
  "REPORT": {
    "HEADER": "Conversas",
    "LOADING_CHART": "A carregar dados...",
    "NO_ENOUGH_DATA": "Não recebemos pontos de dados suficientes para gerar o relatório. Por favor, tente novamente mais tarde.",
    "DOWNLOAD_CONVERSATION_REPORTS": "Baixar relatórios de conversas",
    "DATA_FETCHING_FAILED": "Não foi possível obter dados. Por favor, tente mais tarde.",
    "SUMMARY_FETCHING_FAILED": "Não foi possível obter o resumo. Por favor, tente mais tarde.",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Conversas",
        "DESC": "( Total )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Mensagens recebidas",
        "DESC": "( Total )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Mensagens enviadas",
        "DESC": "( Total )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "Primeiro tempo de resposta",
        "DESC": "( Média )",
        "INFO_TEXT": "Número total de conversas utilizadas para cálculo:",
        "TOOLTIP_TEXT": "O tempo da primeira resposta é {metricValue} (com base em {conversationCount} conversas)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Tempo de resolução",
        "DESC": "( Média )",
        "INFO_TEXT": "Número total de conversas utilizadas para cálculo:",
        "TOOLTIP_TEXT": "O tempo da primeira resposta é {metricValue} (com base em {conversationCount} conversas)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Contagem de resolução",
        "DESC": "( Total )"
      },
      "BOT_RESOLUTION_COUNT": {
        "NAME": "Contagem de resolução",
        "DESC": "( Total )"
      },
      "BOT_HANDOFF_COUNT": {
        "NAME": "Contagem de transferências",
        "DESC": "( Total )"
      },
      "REPLY_TIME": {
        "NAME": "Tempo de espera do cliente",
        "TOOLTIP_TEXT": "O tempo de espera é {metricValue} (com base em {conversationCount} conversas)",
        "DESC": ""
      }
    },
    "DATE_RANGE_OPTIONS": {
      "LAST_7_DAYS": "Últimos 7 Dias",
      "LAST_14_DAYS": "Últimos 14 Dias",
      "LAST_30_DAYS": "Últimos 30 Dias",
      "THIS_MONTH": "This month",
      "LAST_MONTH": "Last month",
      "LAST_3_MONTHS": "Últimos 3 meses",
      "LAST_6_MONTHS": "Últimos 6 meses",
      "LAST_YEAR": "Último ano",
      "CUSTOM_DATE_RANGE": "Intervalo de tempo personalizado"
    },
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Confirmar",
      "PLACEHOLDER": "Selecionar intervalo de tempo"
    },
    "GROUP_BY_FILTER_DROPDOWN_LABEL": "Agrupar por",
    "DURATION_FILTER_LABEL": "Duração",
    "GROUPING_OPTIONS": {
      "DAY": "Dia",
      "WEEK": "Semana",
      "MONTH": "Mês",
      "YEAR": "Ano"
    },
    "GROUP_BY_DAY_OPTIONS": [
      {
        "id": 1,
        "groupBy": "Dia"
      }
    ],
    "GROUP_BY_WEEK_OPTIONS": [
      {
        "id": 1,
        "groupBy": "Dia"
      },
      {
        "id": 2,
        "groupBy": "Semana"
      }
    ],
    "GROUP_BY_MONTH_OPTIONS": [
      {
        "id": 1,
        "groupBy": "Dia"
      },
      {
        "id": 2,
        "groupBy": "Semana"
      },
      {
        "id": 3,
        "groupBy": "Mês"
      }
    ],
    "GROUP_BY_YEAR_OPTIONS": [
      {
        "id": 2,
        "groupBy": "Semana"
      },
      {
        "id": 3,
        "groupBy": "Mês"
      },
      {
        "id": 4,
        "groupBy": "Ano"
      }
    ],
    "BUSINESS_HOURS": "Horário comercial",
    "FILTER_ACTIONS": {
      "CLEAR_FILTER": "Limpar filtros",
      "EMPTY_LIST": "Nenhum resultado encontrado"
    },
    "DRILLDOWN": {
      "TITLE": "{metric} details",
      "RESULT_COUNT_CONVERSATION": "{count} conversation | {count} conversations",
      "RESULT_COUNT_MESSAGE": "{count} message | {count} messages",
      "EMPTY": "No records found for this bar.",
      "ERROR": "Could not load records. Please try again.",
      "ADMIN_ONLY": "Only administrators can drill down into report records.",
      "LOAD_MORE": "Load more",
      "CLOSE": "Close details",
      "PREVIOUS_BUCKET": "Previous bar",
      "NEXT_BUCKET": "Next bar",
      "UNKNOWN_CONTACT": "Unknown contact",
      "UNKNOWN_INBOX": "Unknown inbox",
      "UNASSIGNED_AGENT": "Não atribuída",
      "NO_MESSAGE_CONTENT": "No message content",
      "MESSAGE_CREATED_AT": "Message created at {time}",
      "EVENT_OCCURRED_AT": "Event occurred at {time}",
      "INCOMING_MESSAGE": "Incoming message",
      "OUTGOING_MESSAGE": "Outgoing message"
    },
    "PAGINATION": {
      "RESULTS": "Showing {start} to {end} of {total} results",
      "PER_PAGE_TEMPLATE": "{size} / page"
    }
  },
  "AGENT_REPORTS": {
    "HEADER": "Visão geral de agentes",
    "DESCRIPTION": "Easily track agent performance with key metrics such as conversations, response times, resolution times, and resolved cases. Click an agent's name to learn more.",
    "LOADING_CHART": "A carregar dados...",
    "NO_ENOUGH_DATA": "Não recebemos pontos de dados suficientes para gerar o relatório. Por favor, tente novamente mais tarde.",
    "DOWNLOAD_AGENT_REPORTS": "Descarregar relatórios de agentes",
    "FILTER_DROPDOWN_LABEL": "Selecionar agente",
    "FILTERS": {
      "INPUT_PLACEHOLDER": {
        "AGENTS": "Procurar agentes"
      }
    },
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Conversas",
        "DESC": "( Total )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Mensagens recebidas",
        "DESC": "( Total )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Mensagens de saída",
        "DESC": "( Total )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "Primeiro tempo de resposta",
        "DESC": "( Média )",
        "INFO_TEXT": "Número total de conversas utilizadas para cálculo:",
        "TOOLTIP_TEXT": "O tempo da primeira resposta é {metricValue} (com base em {conversationCount} conversas)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Tempo de resolução",
        "DESC": "( Média )",
        "INFO_TEXT": "Número total de conversas utilizadas para cálculo:",
        "TOOLTIP_TEXT": "O tempo da primeira resposta é {metricValue} (com base em {conversationCount} conversas)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Contagem de resolução",
        "DESC": "( Total )"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "Últimos 7 Dias"
      },
      {
        "id": 1,
        "name": "Últimos 30 Dias"
      },
      {
        "id": 2,
        "name": "Últimos 3 meses"
      },
      {
        "id": 3,
        "name": "Últimos 6 meses"
      },
      {
        "id": 4,
        "name": "Último ano"
      },
      {
        "id": 5,
        "name": "Intervalo de tempo personalizado"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Confirmar",
      "PLACEHOLDER": "Selecionar intervalo de tempo"
    }
  },
  "LABEL_REPORTS": {
    "HEADER": "Visão geral de etiquetas",
    "DESCRIPTION": "Rastreie o desempenho com métricas-chave, incluindo conversas, tempos de resposta, tempos de resolução e casos resolvidos. Clique num nome de rótulo para informações detalhadas.",
    "LOADING_CHART": "A carregar dados...",
    "NO_ENOUGH_DATA": "Não recebemos pontos de dados suficientes para gerar o relatório. Por favor, tente novamente mais tarde.",
    "DOWNLOAD_LABEL_REPORTS": "Descarregar relatórios de etiquetas",
    "FILTER_DROPDOWN_LABEL": "Selecionar etiqueta",
    "FILTERS": {
      "INPUT_PLACEHOLDER": {
        "LABELS": "Procurar etiquetas"
      }
    },
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Conversas",
        "DESC": "( Total )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Mensagens recebidas",
        "DESC": "( Total )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Mensagens de saída",
        "DESC": "( Total )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "Primeiro tempo de resposta",
        "DESC": "( Média )",
        "INFO_TEXT": "Número total de conversas utilizadas para cálculo:",
        "TOOLTIP_TEXT": "O tempo da primeira resposta é {metricValue} (com base em {conversationCount} conversas)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Tempo de resolução",
        "DESC": "( Média )",
        "INFO_TEXT": "Número total de conversas utilizadas para cálculo:",
        "TOOLTIP_TEXT": "O tempo da primeira resposta é {metricValue} (com base em {conversationCount} conversas)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Contagem de resolução",
        "DESC": "( Total )"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "Últimos 7 Dias"
      },
      {
        "id": 1,
        "name": "Últimos 30 Dias"
      },
      {
        "id": 2,
        "name": "Últimos 3 meses"
      },
      {
        "id": 3,
        "name": "Últimos 6 meses"
      },
      {
        "id": 4,
        "name": "Último ano"
      },
      {
        "id": 5,
        "name": "Intervalo de tempo personalizado"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Confirmar",
      "PLACEHOLDER": "Selecionar intervalo de tempo"
    }
  },
  "INBOX_REPORTS": {
    "HEADER": "Visão geral da caixa de entrada",
    "DESCRIPTION": "Quickly view your inbox performance with key metrics like conversations, response times, resolution times, and resolved cases—all in one place. Click an inbox name for more details.",
    "LOADING_CHART": "A carregar dados...",
    "NO_ENOUGH_DATA": "Não recebemos pontos de dados suficientes para gerar o relatório. Por favor, tente novamente mais tarde.",
    "DOWNLOAD_INBOX_REPORTS": "Descarregar relatórios de caixa de entrada",
    "FILTER_DROPDOWN_LABEL": "Escolher caixa de entrada",
    "ALL_INBOXES": "All Inboxes",
    "SEARCH_INBOX": "Search Inbox",
    "FILTERS": {
      "INPUT_PLACEHOLDER": {
        "INBOXES": "Search inboxes"
      }
    },
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Conversas",
        "DESC": "( Total )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Mensagens recebidas",
        "DESC": "( Total )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Mensagens de saída",
        "DESC": "( Total )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "Primeiro tempo de resposta",
        "DESC": "( Média )",
        "INFO_TEXT": "Número total de conversas utilizadas para cálculo:",
        "TOOLTIP_TEXT": "O tempo da primeira resposta é {metricValue} (com base em {conversationCount} conversas)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Tempo de resolução",
        "DESC": "( Média )",
        "INFO_TEXT": "Número total de conversas utilizadas para cálculo:",
        "TOOLTIP_TEXT": "O tempo da primeira resposta é {metricValue} (com base em {conversationCount} conversas)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Contagem de resolução",
        "DESC": "( Total )"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "Últimos 7 Dias"
      },
      {
        "id": 1,
        "name": "Últimos 30 Dias"
      },
      {
        "id": 2,
        "name": "Últimos 3 meses"
      },
      {
        "id": 3,
        "name": "Últimos 6 meses"
      },
      {
        "id": 4,
        "name": "Último ano"
      },
      {
        "id": 5,
        "name": "Intervalo de tempo personalizado"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Confirmar",
      "PLACEHOLDER": "Selecionar intervalo de tempo"
    }
  },
  "TEAM_REPORTS": {
    "HEADER": "Visão geral da equipa",
    "DESCRIPTION": "Get a snapshot of your team's performance with essential metrics, including conversations, response times, resolution times, and resolved cases. Click a team name for more details.",
    "LOADING_CHART": "A carregar dados...",
    "NO_ENOUGH_DATA": "Não recebemos pontos de dados suficientes para gerar o relatório. Por favor, tente novamente mais tarde.",
    "DOWNLOAD_TEAM_REPORTS": "Descarregar relatórios de equipa",
    "FILTER_DROPDOWN_LABEL": "Selecionar equipa",
    "FILTERS": {
      "ADD_FILTER": "Adicionar filtro",
      "CLEAR_ALL": "Limpar tudo",
      "NO_FILTER": "Sem filtros disponíveis",
      "INPUT_PLACEHOLDER": {
        "TEAMS": "Procurar equipas"
      }
    },
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Conversas",
        "DESC": "( Total )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Mensagens recebidas",
        "DESC": "( Total )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Mensagens de saída",
        "DESC": "( Total )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "Primeiro tempo de resposta",
        "DESC": "( Média )",
        "INFO_TEXT": "Número total de conversas utilizadas para cálculo:",
        "TOOLTIP_TEXT": "O tempo da primeira resposta é {metricValue} (com base em {conversationCount} conversas)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Tempo de resolução",
        "DESC": "( Média )",
        "INFO_TEXT": "Número total de conversas utilizadas para cálculo:",
        "TOOLTIP_TEXT": "O tempo da primeira resposta é {metricValue} (com base em {conversationCount} conversas)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Contagem de resolução",
        "DESC": "( Total )"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "Últimos 7 Dias"
      },
      {
        "id": 1,
        "name": "Últimos 30 Dias"
      },
      {
        "id": 2,
        "name": "Últimos 3 meses"
      },
      {
        "id": 3,
        "name": "Últimos 6 meses"
      },
      {
        "id": 4,
        "name": "Último ano"
      },
      {
        "id": 5,
        "name": "Intervalo de tempo personalizado"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Confirmar",
      "PLACEHOLDER": "Selecionar intervalo de tempo"
    }
  },
  "CSAT_REPORTS": {
    "HEADER": "Relatórios CSAT",
    "NO_RECORDS": "No responses yet",
    "NO_RECORDS_DESCRIPTION": "CSAT survey responses will appear here once customers start providing feedback.",
    "DOWNLOAD": "Descarregar relatórios CSAT",
    "DOWNLOAD_FAILED": "Falha ao descarregar os relatórios CSAT",
    "FILTERS": {
      "ADD_FILTER": "Adicionar filtro",
      "CLEAR_ALL": "Limpar tudo",
      "NO_FILTER": "Sem filtros disponíveis",
      "INPUT_PLACEHOLDER": {
        "AGENTS": "Procurar agentes",
        "INBOXES": "Search inboxes",
        "TEAMS": "Procurar equipas",
        "RATINGS": "Search ratings"
      },
      "AGENTS": {
        "LABEL": "Agente"
      },
      "INBOXES": {
        "LABEL": "Caixa de entrada"
      },
      "TEAMS": {
        "LABEL": "Equipa"
      },
      "RATINGS": {
        "LABEL": "Avaliar"
      }
    },
    "TABLE": {
      "HEADER": {
        "CONTACT_NAME": "Contacto",
        "AGENT_NAME": "Agente",
        "RATING": "Classificação",
        "FEEDBACK_TEXT": "Comentário de feedback",
        "CONVERSATION": "Conversa",
        "CUSTOMER": "Customer",
        "RESPONSE": "Response",
        "HANDLED_BY": "Handled by"
      },
      "UNKNOWN_CUSTOMER": "Unknown customer"
    },
    "NO_AGENT": "No assigned agent",
    "NO_FEEDBACK": "No feedback provided",
    "METRIC": {
      "TOTAL_RESPONSES": {
        "LABEL": "Total de respostas",
        "TOOLTIP": "Número total de respostas recolhidas"
      },
      "SATISFACTION_SCORE": {
        "LABEL": "Pontuação de satisfação",
        "TOOLTIP": "Número total de respostas positivas / Número total de respostas * 100"
      },
      "RESPONSE_RATE": {
        "LABEL": "Taxa de resposta",
        "TOOLTIP": "Número total de respostas / Número total de mensagens de questionários CSAT enviadas * 100"
      },
      "RATING_DISTRIBUTION": "Rating distribution"
    },
    "REVIEW_NOTES": {
      "TITLE": "Review notes",
      "PLACEHOLDER": "Add review notes about this rating...",
      "SAVE": "Guardar",
      "CANCEL": "Cancelar",
      "SAVING": "A guardar...",
      "SAVED": "Notes saved successfully",
      "SAVE_ERROR": "Failed to save notes",
      "UPDATED_BY": "Updated by {name} {time}",
      "UPDATED_BY_LABEL": "Updated by",
      "PAYWALL": {
        "TITLE": "Upgrade to add review notes",
        "AVAILABLE_ON": "The review notes feature is only available in the Business and Enterprise plans.",
        "UPGRADE_PROMPT": "Add internal context to every CSAT response with review notes. Capture what really happened, spot patterns faster, and make better decisions from your feedback.",
        "UPGRADE_NOW": "Fazer upgrade agora",
        "CANCEL_ANYTIME": "Pode alterar ou cancelar o plano a qualquer momento"
      }
    }
  },
  "BOT_REPORTS": {
    "HEADER": "Relatórios de bot",
    "METRIC": {
      "TOTAL_CONVERSATIONS": {
        "LABEL": "N.º de conversas",
        "TOOLTIP": "Número total de conversas tratadas pelo bot"
      },
      "TOTAL_RESPONSES": {
        "LABEL": "Total de respostas",
        "TOOLTIP": "Número total de respostas enviadas pelo bot"
      },
      "RESOLUTION_RATE": {
        "LABEL": "Taxa de resolução",
        "TOOLTIP": "Número total de conversas resolvidas pelo bot / Número total de conversas tratadas pelo bot * 100"
      },
      "HANDOFF_RATE": {
        "LABEL": "Taxa de transferência",
        "TOOLTIP": "Número total de conversas transferidas para agentes / Número total de conversas tratadas pelo bot * 100"
      }
    }
  },
  "OVERVIEW_REPORTS": {
    "HEADER": "Visão geral",
    "LIVE": "Disponível",
    "ACCOUNT_CONVERSATIONS": {
      "HEADER": "Conversas abertas",
      "LOADING_MESSAGE": "A carregar métricas de conversa...",
      "OPEN": "Abertas",
      "UNATTENDED": "Por responder",
      "UNASSIGNED": "Não atribuída",
      "PENDING": "Pendente"
    },
    "CONVERSATION_HEATMAP": {
      "HEADER": "Tráfego de conversa",
      "NO_CONVERSATIONS": "Não existem conversas",
      "CONVERSATION": "{count} conversa",
      "CONVERSATIONS": "{count} conversas",
      "DOWNLOAD_REPORT": "Descarregar relatório"
    },
    "RESOLUTION_HEATMAP": {
      "HEADER": "Resolutions",
      "NO_CONVERSATIONS": "Não existem conversas",
      "CONVERSATION": "{count} conversa",
      "CONVERSATIONS": "{count} conversas",
      "DOWNLOAD_REPORT": "Descarregar relatório"
    },
    "AGENT_CONVERSATIONS": {
      "HEADER": "Conversas por agentes",
      "LOADING_MESSAGE": "A gerar métricas dos agentes...",
      "NO_AGENTS": "Não existem conversas por agentes",
      "TABLE_HEADER": {
        "AGENT": "Agente",
        "OPEN": "Abertas",
        "UNATTENDED": "Por responder",
        "STATUS": "Estado"
      }
    },
    "TEAM_CONVERSATIONS": {
      "ALL_TEAMS": "All Teams",
      "HEADER": "Conversations by teams",
      "LOADING_MESSAGE": "Loading team metrics...",
      "NO_TEAMS": "There is no data available",
      "TABLE_HEADER": {
        "TEAM": "Equipa",
        "OPEN": "Abertas",
        "UNATTENDED": "Por responder",
        "STATUS": "Situação"
      }
    },
    "AGENT_STATUS": {
      "HEADER": "Estado do agente",
      "ONLINE": "Disponível",
      "BUSY": "Ocupado",
      "OFFLINE": "Ausente"
    }
  },
  "DAYS_OF_WEEK": {
    "SUNDAY": "Domingo",
    "MONDAY": "Segunda-feira",
    "TUESDAY": "Terça-feira",
    "WEDNESDAY": "Quarta-feira",
    "THURSDAY": "Quinta-feira",
    "FRIDAY": "Sexta-feira",
    "SATURDAY": "Sábado"
  },
  "SLA_REPORTS": {
    "HEADER": "Relatórios SLA",
    "NO_RECORDS": "Conversas com SLA aplicadas não estão disponíveis.",
    "LOADING": "A carregar dados SLA...",
    "DOWNLOAD_SLA_REPORTS": "Descarregar relatórios SLA",
    "DOWNLOAD_FAILED": "Falha ao efetuar download dos relatórios SLA",
    "DROPDOWN": {
      "ADD_FIlTER": "Adicionar filtro",
      "CLEAR_ALL": "Limpar tudo",
      "CLEAR_FILTER": "Limpar filtros",
      "EMPTY_LIST": "Nenhum resultado encontrado",
      "NO_FILTER": "Sem filtros disponíveis",
      "SEARCH": "Procurar filtros",
      "INPUT_PLACEHOLDER": {
        "SLA": "Nome SLA",
        "AGENTS": "Nome do agente",
        "INBOXES": "Nome da caixa de entrada",
        "LABELS": "Nome da etiqueta",
        "TEAMS": "Nome da equipa"
      },
      "SLA": "Política SLA",
      "INBOXES": "Caixa de entrada",
      "AGENTS": "Agente",
      "LABELS": "Etiqueta",
      "TEAMS": "Equipa"
    },
    "WITH": "com",
    "METRICS": {
      "HIT_RATE": {
        "LABEL": "Taxa de sucesso",
        "TOOLTIP": "Percentagem de SLA criadas foi completada com sucesso"
      },
      "NO_OF_MISSES": {
        "LABEL": "Número de perdas",
        "TOOLTIP": "Total de SLA perdidas num determinado período"
      },
      "NO_OF_CONVERSATIONS": {
        "LABEL": "Número de conversas",
        "TOOLTIP": "Número total de conversas com SLA"
      }
    },
    "TABLE": {
      "HEADER": {
        "POLICY": "Política",
        "CONVERSATION": "Conversa",
        "AGENT": "Agente"
      },
      "VIEW_DETAILS": "Ver detalhes"
    }
  },
  "SUMMARY_REPORTS": {
    "INBOX": "Caixa de entrada",
    "AGENT": "Agente",
    "TEAM": "Equipa",
    "LABEL": "Etiqueta",
    "AVG_RESOLUTION_TIME": "Avg. Resolution Time",
    "AVG_FIRST_RESPONSE_TIME": "Avg. First Response Time",
    "AVG_REPLY_TIME": "Avg. Customer Waiting Time",
    "RESOLUTION_COUNT": "Contagem de resolução",
    "CONVERSATIONS": "Num de conversas"
  }
}
